import vue from 'vue';
import toggleloading from './toggleloading';
const loadingClass = vue.extend(toggleloading);
let j_loading = document.createElement('div');
const vmLoading = new loadingClass();
vmLoading.$mount(j_loading);
document.body.appendChild(vmLoading.$el);

const Mainhide = function () {
  vmLoading.canShow = false;
};
const MainShow = function () {
  vmLoading.canShow = true;
};
function config() {
  vue.prototype.$hideLoading = Mainhide;
  vue.prototype.$showLoading = MainShow;
}

export default config;



// WEBPACK FOOTER //
// ./src/components/toggleloading/config.js